<template>
    <div id="Acompanhamento" v-if="checarVizualisacao()">

        <div class="row">
            <div class="col s12">
             <div id="modal-comments" class="modal modal-fixed-footer">
                <div class="modal-content pt-0 pl-0 pr-0" style="overflow:hidden">
                    <div class="modal-header">
                        <div class="row pt-2">
                            <div class="col m12">
                                <h4 class="ml-2 header2">Comentários</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col m12" style="heigth:250px;">
                         <div class="row">
                            <div class="col s12">
                                <chat :history="comentariosListagem" />
                            </div>
                        </div>
                    </div>

                </div>
            <div class="modal-footer">
                    <form>
                        <div class="input-field col s12 container">
                            <textarea id="textarea1" v-model="textoComentario" class="materialize-textarea"></textarea>
                            <!-- <label for="textarea1">Comentário</label> -->
                            <button class="btn cyan waves-effect waves-light right mb-1" type="button" name="action" v-on:click="salvarComentario()">
                            Salvar
                            <!-- <i class="material-icons right">send</i> -->
                            </button>
                        </div>
                    </form>
                <div class="col s12 container grey lighten-3">
                    <button @click="closeComentario()" class="modal-action modal-close btn waves-effect waves-light grey darken-1">Fechar</button>
                </div>
            </div>
        </div>

             <table class="striped list" v-if="acompanhamentoListagem" style="font-size: 12px; table-layout: auto;">
                <thead>
                    <tr>
                        <th class="colConsultor hide-on-med-and-down" style="padding-top: 39px">
                            CONSULTOR
                        </th>

                        <th class="colTipo" style="padding-top: 20px">
                            ESTADO
                        </th>
                        <th class="colData hide-on-med-and-down" style="padding-top: 23px">
                            DATA DE CRIAÇÃO
                        </th>
                        <th class="colData hide-on-med-and-down" style="padding-top: 23px">
                            DATA DE AGENDAMENTO
                        </th>
                        <th class="colEmpresa hide-on-med-and-down" style="padding-top: 29px">
                            EMPRESA/CARGO
                        </th>
                        <th class="colObs table-obs hide-on-med-and-down" style="padding-top: 20px">
                            OBSERVAÇÕES
                        </th>
                         <th class="colTipo hide-on-med-and-down" style="padding-top: 20px">
                            TIPO
                        </th>
                        <th class="colStatus" style="padding-top: 20px">
                            STATUS
                        </th>
                        <th class="colAcoes" style="padding-top: 36px" v-if="checaCargoUsuario([cargoGerente, cargoEspecialista, cargoDono])">
                            AÇÕES
                        </th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(estagio, index) in list" :key="`item-${index}`">
                    <td class="group-avatar  hide-on-med-and-down">
                        <div style="display: flex; align-item: center; height: 100%" v-if="estagio.funcionario">
                            <i v-if="!estagio.funcionario.pessoa.pessoa_avatar" class="material-icons circle">person</i>
                            <img v-if="estagio.funcionario.pessoa.pessoa_avatar" :src="estagio.funcionario.pessoa.pessoa_avatar" alt="" class="circle">
                            <span class="group-avatar-name">{{ estagio.funcionario.pessoa.pessoa_nome }}</span>
                        </div>
                    </td>

                    <td>
                        <span :class="'tag-estado white-text border-radius-2 contact-featured '+estagio.secondColor" >
                            {{estagio.map_tipo}}
                        </span>
                    </td>
                    <td class="hide-on-med-and-down">
                        {{ estagio.map_datas }}
                        <template v-if="estagio.funcionario_responsavel">
                            por
                            <strong>{{ estagio.funcionario_responsavel.pessoa.pessoa_nome }}</strong>
                        </template>
                    </td>
                    <td>
                        {{ estagio.pedido_contato_data | moment("DD/MM/YYYY HH:mm") }}
                    </td>
                    <td class="hide-on-med-and-down">
                        <template v-if="estagio.map_funcionario">
                            {{ estagio.map_funcionario.empresa }} - {{estagio.map_funcionario.cargo}}
                        </template>
                        <template v-else>
                            SITE
                        </template>
                    </td>
                    <td class="hide-on-med-and-down">{{ estagio.map_observacoes }}</td>
                    <td class="hide-on-med-and-down tipo-contato" style="first-letter: capitalize !important">{{ getContatoTipo(estagio) }}</td>
                    <td>
                        {{ estagio.map_status }}
                    </td>
                    <td >
                        <button
                               v-if="checaCargoUsuario([cargoGerente, cargoEspecialista, cargoDono]) && estagio.map_acoes"
                                @click="setCustomStage(estagio)"
                                class="waves-effect waves-teal btn-flat"
                                v-tooltip.left="'Voltar para esse estágio'"
                            >
                                <i class="material-icons" style="">gps_fixed</i>
                            </button>
                            <!--<button
                                v-if="checaCargoUsuario([cargoGerente, cargoEspecialista, cargoDono]) && estagio.map_acoes"
                                @click="abreModalHistorico()"
                                class="waves-effect waves-teal btn-flat"
                                v-tooltip.right="'Visualize a negociação'"
                            >
                                <i class="material-icons">remove_red_eye</i>
                            </button>-->
                            <button
                                v-if="checaCargoUsuario([cargoGerente, cargoEspecialista, cargoDono]) && estagio.map_acoes"
                                @click="setShowAddComentario(estagio)"
                                class="waves-effect waves-teal btn-flat"
                                v-tooltip.left="'Adicione um comentário'"
                            >
                                <div style="display:flex; flex-direction: column; position: relative">
                                    <span class="badge badge-circle" v-if="estagio.pedido_historico_observacoes.length">{{estagio.pedido_historico_observacoes.length}}</span>
                                    <i class="material-icons" style="">comment</i>

                                </div>
                            </button>
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="list.length === 0">Nenhum historico registrado!</p>
            </div>
        </div>

        <!-- Modal Congelar -->
        <div id="modalNegociacao" class="modal modal-fixed-footer">
            <div class="modal-content pt-0 pl-0 pr-0">
                <div class="modal-header">
                    <div class="row pt-2">
                        <div class="col m12">
                            <h4 class="ml-2 header2">Histório de negociação</h4>
                        </div>
                    </div>
                </div>
                <div class="col m12">
                    <div class="row">
                        <div class="col m12">
                            <h5 class="title">Contatos feitos</h5>
                            <ul class="collection z-depth-1">
                                <li class="" v-if="estagio.pedido_contato_avulso_estagio === 'N'" v-for="estagio in pedido.pedido_contato_avulsos">
                                    <!-- <div class="collapsible-header waves-light white-text gradient-45deg-purple-deep-purple">
                                        <i class="material-icons">perm_phone_msg</i>
                                        {{ estagio.funcionario ? estagio.funcionario.pessoa.pessoa_nome : '' }} -
                                        {{ estagio.pedido_contato_avulso_tipo }} -
                                        {{ getContatoStatus(estagio.pedido_contato_avulso_estado_id) }}<br>
                                        {{ estagio.funcionario ? estagio.funcionario.empresa.empresa_nome_fantasia : '' }} -
                                        {{ estagio.funcionario ? estagio.funcionario.funcionario_cargo.funcionario_cargo_nome: '' }}<br>
                                        {{getData(estagio.pedido_contato_avulso_data)}}<br>
                                        Observações: {{ estagio.pedido_contato_avulso_observacoes }}
                                    </div> -->
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col m12">
                            <h5 class="title">Visitas realizadas</h5>
                            <ul id="" class="collection z-depth-1">
                                <li v-for="(estagio, index) in pedido.pedido_visita_avulsas" :key="`estagio-item-${index}`">
                                    <div class="collapsible-header waves-light white-text gradient-45deg-light-blue-cyan">
                                        <i class="material-icons">perm_contact_calendar</i>
                                        <template v-if="estagio.funcionario">
                                            {{ estagio.funcionario.pessoa.pessoa_nome }}
                                        </template> -
                                        {{ estagio.pedido_visita_avulsa_tipo }} -
                                        {{ getVisitaStatus(estagio.pedido_visita_avulsa_estado_id) }}<br>

                                        <template v-if="estagio.funcionario">
                                            {{ estagio.funcionario.empresa.empresa_nome_fantasia }} -
                                            {{ estagio.funcionario.funcionario_cargo.funcionario_cargo_nome }}<br>
                                        </template>
                                        {{ getData(estagio.pedido_visita_avulsa_data) }}<br>
                                        Observações: {{ estagio.pedido_visita_avulsa_observacoes }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer grey lighten-3">
                <button class="modal-action modal-close btn waves-effect waves-light grey darken-1">Cancelar</button>
            </div>
        </div>



    </div>
</template>

<style>
    #Acompanhamento .modal .modal-footer{
        height: auto !important;
    }
    .badge-circle{
        margin: 0;
        padding: 0;
        position: absolute;
        z-index: 999;
        left: -4px;
        top: 1px;
        min-width: auto !important;
        background: #F00;
        border-radius: 50%;
        height: 12px !important;
        width: 12px;
        color: #fff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.6em !important;
        margin: 0;
        padding: 0 !important;
        border: 0;
        padding-top: 2px !important;
        padding-right: 1px !important;
    }
    @media (max-width: 601px){
        .hide-on-small{
            display: none !important;
        }
        .show-on-small{
            display: block !important;
        }
    }
    @media (min-width: 600px){
        .table-obs{
            width: 163px;
        }
        .show-on-small{
            display: none !important;
        }
        .hide-on-small{
            display: block !important;
        }

    }
    .contact-featured{
        padding: 3px 10px;
    }

    #Acompanhamento .list tbody{
        position: relative;
        height: 200px;
        overflow-y: auto;
    }
    #Acompanhamento  .circle{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #dededeee;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    #Acompanhamento .circle.empty{
        background: transparent;
    }

    #Acompanhamento .group-avatar{
        /* display: flex; */
        align-items: center;
        flex-wrap: wrap;
        top: 50%;
        display: table-cell;
        vertical-align: middle;
    }
    #Acompanhamento .group-avatar-name{
        margin-left: 5px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    #Acompanhamento .list{
        margin-bottom: 20px;
    }
    #Acompanhamento .list .btn-flat{
        padding: 0 2px;
    }

    @media (min-width: 999px){
        #Acompanhamento .list th{
            padding-top: 10px !important;
        }

}
.form-fixed{
    bottom: 50px;
    position: fixed;
    background-color: #fafafa;
}

@media (max-width: 1440px) {
    #Acompanhamento tr th{
    font-size: 13px !important;

    }
}

</style>

<script>
    import {
        ESTAGIO_PROSPECCAO,
        ESTAGIO_CHAMADA_TELEFONICA,
        ESTAGIO_PRIMEIRA_VISITA,
        ESTAGIO_EFETIVADO,
        ESTAGIO_NEGATIVADO,
        ESTAGIO_SEGUNDA_VISITA,
        ESTAGIO_EM_ESPERA,
        ESTAGIO_PERDIDO,
        ESTAGIO_NEGOCIACAO
    } from '@/constants/pedidoEstagio.js';
    import { DONO, GERENTE, CORRETOR, ESPECIALISTA, PARCEIRO, MASTER } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import { post } from '@/helpers/api';
    import Message from '@/helpers/message';
    import Chat from '@/components/common/Chat';
    import { Event } from '@/helpers/events';
    import ConverterHelper from '@/helpers/converter';

    export default {
        props: ['pedido', 'list'],
        components: {
          Chat,
        },
        data: () => ({
            textoComentario: '',
            showAddComentario: false,
            adicinouComentario: false,
            showNegociacao: false,
            historicoIdCurrent: null,
            usuarioLogadoCargo: null,
            pedidoCurrent: null,
            cargoDono: null,
            cargoGerente: null,
            cargoCorretor: null,
            cargoEspecialista: null,
            cargoParceiro: null,
            usuarioRef:  null,
            comentariosListagem: [],
            estagioNegociacao: ESTAGIO_NEGOCIACAO,
            acompanhamentoListagem: [],
        }),
        created: function () {
            this.usuarioLogadoCargo = Auth.getCargoUsuario();
            this.cargoDono = DONO;
            this.cargoGerente = GERENTE;
            this.cargoCorretor = CORRETOR;
            this.cargoEspecialista = ESPECIALISTA;
            this.cargoParceiro = PARCEIRO;
            this.usuarioRef = Auth.getUserId();
            this.textoComentario = '';

            // this.acompanhamentoListagem = [].concat(this.pedido.pedido_historicos, this.pedido.pedido_contato_avulsos, this.pedido.pedido_visita_avulsas);
        },
        methods: {
            closeComentario(){
                if(this.adicinouComentario){
                    location.reload();
                }
            },

            checarVizualisacao() {
                return typeof this.pedido.pedido_historicos !== 'undefined';
            },
            getContatoTipo(estagio){

                const indice = [
                    'pedido_contato_tipo',
                    'pedido_visita_tipo',
                    'pedido_visita_avulsa_tipo',
                    'pedido_contato_avulso_tipo'
                ].find(key => !!estagio[key]);

                const obj = {
                    'email' : 'E-mail',
                    'reuniao' : 'Reunião',
                    'ligacao' : 'Ligação'
                }

                return obj[estagio[indice]];

            },
            getData(data) {
                return moment(data).format('DD/MM/YYYY HH:mm');
            },
            salvarComentario() {
                let self = this;
                post('pedido-historico/adiciona-observacao', {
                    pedido_historico_observacoes_comentario: this.textoComentario,
                    pedido_historico_id: this.historicoIdCurrent,
                }).then(function (response) {


                    // self.historicoIdCurrent = null;
                    // self.showAddComentario = false;
                    self.comentariosListagem.push({
                        me: true,
                        msg: self.checkReturn(self.textoComentario),
                        name: ''
                    });
                    self.textoComentario = '';
                    Message.messageSuccess(response.data.statusMessage);
                    // console.log('data', response.data);
                     self.$emit('atualiza', [
                        response.data.result.data
                    ]);
                    self.$forceUpdate();
                    self.adicinouComentario = true;
                    // Event.updateComment({
                    //     me: true,
                    //     msg: self.checkReturn(self.textoComentario),
                    //     name: ''
                    // });
                    try{

                        if(self.comentariosListagem.length > 5){
                            const messages = document.querySelector('#Acompanhamento .modal-content');
                            messages.scrollBottom = messages.scrollHeight + 20;

                        }
                    }


                    catch(ex){}

                    // location.reload();
                }).catch(function (ex) {
                    Message.messageError('Ocorreu um erro ao salvar, tente novamente.');
                });
            },
            setShowAddComentario(estagio) {
            //    debugger;
                this.historicoIdCurrent = estagio.pedido_historico_id;
                this.pedidoCurrent      = estagio.pedido_historico_id;
                const self = this;
                self.comentariosListagem = [];
                estagio.pedido_historico_observacoes.forEach(function (obj) {
                    // console.log(self, obj);
                    self.comentariosListagem.push({
                        me: obj.funcionario_id === self.usuarioRef,
                        msg: self.checkReturn(obj.pedido_historico_observacoes_comentario),
                        name: obj.funcionario.pessoa.pessoa_nome
                    });
                })
                // Events.updateComment(self.comentariosListagem);

                this.showAddComentario  = true;
                    setTimeout(function () {
                        $('#modal-comments').modal();
                        $('#modal-comments').modal('open');
                    }, 500);
            },
            checaCargoUsuario(arrayPode) {
                if (this.usuarioLogadoCargo === MASTER) {
                    return true;
                }
                return arrayPode.indexOf(this.usuarioLogadoCargo) !== -1;
            },
            setCustomStage(estagio) {
                let self = this;
                post('pedido/retornar-historico', {
                    pedido_id: estagio.pedido_id,
                    pedido_historico_id: estagio.pedido_historico_id,
                }).then(function (response) {
                    self.$emit('atualiza', [
                        response.data.result.data
                    ]);

                    Message.messageSuccess(response.data.statusMessage);
                    location.reload();
                }).catch(function () {
                    Message.messageError('Ocorreu um erro ao salvar, tente novamente.');
                });
            },
            checkReturn(string) {
                if (string) {
                    return string;
                }
                return '';
            },
            getContatoStatus(id) {
                switch (id) {
                    case 1:
                        return 'Efetuado e agendado';
                    case 2:
                        return 'Não atendeu';
                    case 3:
                        return 'Telefone ocupado';
                    case 4:
                        return 'Telefone não existe';
                    case 5:
                        return 'Telefone desligado';
                    case 6:
                        return 'Efetuado com retorno';
                    case 7:
                        return 'Não possui mais interesse';
                }
            },
            getVisitaStatus(id) {
                switch (id) {
                    case 1:
                        return 'Marcação';
                    case 2:
                        return 'Efetuada com sucesso';
                    case 3:
                        return 'Remarcada';
                    case 4:
                        return 'Não estava presente';
                    case 5:
                        return 'Cancelada';
                }
            },
            abreModalHistorico() {
                setTimeout(function () {
                    $('#modalNegociacao').modal();
                    $('#modalNegociacao').modal('open');
                }, 500);
            },
        },
        computed: {
            reverseItems() {
                if (typeof this.acompanhamentoListagem === 'undefined') {
                    return [];
                }

                return this.acompanhamentoListagem.filter(function (obj) {
                    return obj.pedido_estagio_id !== ESTAGIO_SEGUNDA_VISITA;
                }).slice().reverse();
            }
        },
        mounted() {
            // console.log('mounted', 1111);
            $('.collapsible').collapsible();
        },
        watch: {
            pedido(newValue) {
                // let order = {
                // 1: {
                //     order: 0,
                //     icon: 'person',
                //     color: 'gradient-45deg-amber-amber',
                //     secondColor: 'blue-aqua-light'
                // },
                // 2: {
                //     order: 1,
                //     icon: 'perm_phone_msg',
                //     color: 'gradient-45deg-purple-deep-purple',
                //     secondColor: 'pink-light'
                // },
                // 3: {
                //     order: 2,
                //     icon: 'perm_contact_calendar',
                //     color: 'gradient-45deg-light-blue-cyan',
                //     secondColor: 'yellow-light'
                // },
                // 9: {
                //     order: 3,
                //     icon: 'attach_money',
                //     color: 'gradient-45deg-purple-light-blue',
                //     secondColor: 'blue-light'
                // },
                // 4: {
                //     order: 4,
                //     icon: 'check',
                //     color: 'gradient-45deg-green-teal',
                //     secondColor: 'green-light'
                // },
                // 5: {
                //     order: 5,
                //     icon: 'close',
                //     color: 'gradient-45deg-red-pink',
                //     secondColor: 'red'
                // },
                // 8: {
                //     order: 6,
                //     icon: 'warning',
                //     color: 'gradient-45deg-red-pink',
                //     secondColor: 'red'
                // },
                // 7: {
                //     order: 7,
                //     icon: 'hourglass_empty',
                //     color: 'gradient-45deg-indigo-light-blue',
                //     secondColor: 'blue darken-4'
                // },
                // };
                // newValue.pedido_visita_avulsas.forEach(function (value) {

                //     if (value.pedido_estagio_id !== ESTAGIO_SEGUNDA_VISITA) {
                //         for (let index in order) {
                //             if (value.pedido_estagio_id == index) {
                //                 value.ordem =  order[index].order;
                //                 value.icon = order[index].icon;
                //                 value.color = order[index].color;
                //                 value.secondColor = order[index].secondColor;
                //             }
                //         }
                //     }
                // });
                // newValue.pedido_historicos.forEach(function (value) {
                //     if (value.pedido_estagio_id !== ESTAGIO_SEGUNDA_VISITA) {
                //         // console.log(11111111, value);
                //         for (let index in order) {
                //             if (value.pedido_estagio_id == index) {
                //                 value.ordem =  order[index].order;
                //                 value.icon = order[index].icon;
                //                 value.color = order[index].color;
                //                 value.secondColor = order[index].secondColor;
                //                 if (value.pedido_estagio_id == ESTAGIO_PROSPECCAO) {
                //                     value.description = '<div class="row"><div class="col m6"><b>Data da indicação:</b> '+this.getData(value.data_criacao)+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+this.pedido.cliente_has_produto.cliente.pessoa.pessoa_observacao+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_CHAMADA_TELEFONICA) {
                //                     let statusContato = '';
                //                     switch (value.pedido_contato_estado_id) {
                //                         case 1:
                //                             statusContato = 'Efetuado e agendado';
                //                             break;
                //                         case 2:
                //                             statusContato = 'Não atendeu';
                //                             break;
                //                         case 3:
                //                             statusContato = 'Telefone ocupado';
                //                             break;
                //                         case 4:
                //                             statusContato = 'Telefone não existe';
                //                             break;
                //                         case 5:
                //                             statusContato = 'Telefone desligado';
                //                             break;
                //                         case 6:
                //                             statusContato = 'Efetuado com retorno';
                //                             break;
                //                         case 7:
                //                             statusContato = 'Não possui mais interesse';
                //                             break;
                //                     }
                //                     value.description = '<div class="row"><div class="col m6"><b>Data do contato:</b> '+this.getData(value.pedido_contato_data)+'</div>' +
                //                         '<div class="col m6"><b>Status do contato:</b> '+statusContato+'</div></div>' +
                //                         '<div class="row"><div class="col m6"><b>Tipo:</b> '+value.pedido_contato_tipo+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+value.pedido_contato_observacoes+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_PRIMEIRA_VISITA) {
                //                     let statusVisita = '';
                //                     switch (value.pedido_visita_estado_id) {
                //                         case 1:
                //                             statusVisita = 'Marcação';
                //                             break;
                //                         case 2:
                //                             statusVisita = 'Efetuada com sucesso';
                //                             break;
                //                         case 3:
                //                             statusVisita = 'Remarcada';
                //                             break;
                //                         case 4:
                //                             statusVisita = 'Não estava presente';
                //                             break;
                //                         case 5:
                //                             statusVisita = 'Cancelada';
                //                     }
                //                     value.description = '<div class="row"><div class="col m6"><b>Data marcada:</b> '+this.getData(value.pedido_visita_data)+'</div>' +
                //                         '<div class="col m6"><b>Status da visita:</b> '+statusVisita+'</div></div>' +
                //                         '<div class="row"><div class="col m6"><b>Tipo:</b> '+value.pedido_visita_tipo+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+value.pedido_visita_observacoes+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_EFETIVADO) {
                //                     let obs = value.pedido_efetivado_observacao;
                //                     if (obs === null) {
                //                         obs = '';
                //                     }
                //                     value.description = '<div class="row"><div class="col m6"><b>Data efetivação:</b> '+this.getData(value.data_criacao)+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+obs+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_EM_ESPERA) {
                //                     let obs = value.pedido_cold_observacao;
                //                     if (obs === null) {
                //                         obs = '';
                //                     }
                //                     value.description = '<div class="row"><div class="col m6"><b>Data de sinalização:</b> '+this.getData(value.data_criacao)+'</div>' +
                //                         '<div class="col m6"><b>Data de retorno:</b> '+this.getData(value.pedido_cold_data_retorno)+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+obs+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_PERDIDO) {
                //                     let obs = value.pedido_lost_observacao;
                //                     if (obs === null) {
                //                         obs = '';
                //                     }

                //                     let statusLost = '';
                //                     switch (value.pedido_lost_motivo) {
                //                         case 1:
                //                             statusLost = 'Negativado com sucesso';
                //                             break;
                //                     }
                //                     value.description = '<div class="row"><div class="col m6"><b>Data de sinalização:</b> '+this.getData(value.data_criacao)+'</div>' +
                //                         '<div class="col m6"><b>Motivo:</b> '+statusLost+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+obs+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_NEGATIVADO) {
                //                     let obs = value.pedido_nao_efetivado_observacao;
                //                     if (obs === null) {
                //                         obs = '';
                //                     }

                //                     let statusLost = '';
                //                     switch (value.pedido_nao_efetivado_motivo) {
                //                         case 1:
                //                             statusLost = 'Negativado com sucesso';
                //                             break;
                //                     }
                //                     value.description = '<div class="row"><div class="col m6"><b>Data negativação:</b> '+this.getData(value.data_criacao)+'</div>' +
                //                         '<div class="col m6"><b>Motivo:</b> '+statusLost+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> '+obs+'</div></div>';
                //                 } else if (value.pedido_estagio_id == ESTAGIO_NEGOCIACAO) {
                //                     value.description = '<div class="row"><div class="col m6"><b>Data início:</b> '+this.getData(value.data_criacao)+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Empresa/Cargo responsável</b> '+value.funcionario.empresa.empresa_nome_fantasia+'/'+value.funcionario.funcionario_cargo.funcionario_cargo_nome+'</div></div>' +
                //                         '<div class="row"><div class="col m12"><b>Observações:</b> Em negociação</div></div>';
                //                 }
                //             }
                //         }
                //     }
                // }, this);
                // // this.acompanhamentoListagem.concat(this.pedido.pedido_historicos, this.pedido.pedido_contato_avulsos, this.pedido.pedido_visita_avulsas);

            }
        },

        filters: {
            moment: (value, format) => {

                const date = moment(value);

                return date.isValid() ? date.format(format) : '-';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/Acompanhamento.vue